import React from "react";

import { useTranslation } from "react-i18next";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./infoCard.css";

export default function InfoCardHome() {
  const { t } = useTranslation();
  const cards = [
    {
      id: 1,
      title: t("INFOCARD.CARD1_TITLE"),
      description: t("INFOCARD.CARD1_DESC"),
      description2: t("INFOCARD.CARD1_DESC2"),
      icon: "/images/InfoCardHome3.png",
      logos: "",
      moreText: ""
    },
    {
      id: 2,
      title: t("INFOCARD.CARD2_TITLE"),
      description: t("INFOCARD.CARD2_DESC"),
      description2: t("INFOCARD.CARD2_DESC2"),
      icon: "/images/InfoCardHome2.png",
      logos: "",
      moreText: ""
    },
    {
      id: 3,
      title: t("INFOCARD.CARD3_TITLE"),
      description: t("INFOCARD.CARD3_DESC"),
      description2: t("INFOCARD.CARD3_DESC2"),
      icon: "/images/InfoCardHome5.png",
      logos: [
        // "/images/footer_img1.png",
        // "/images/footer_img3.png",
        // "/images/7-eleven_logo1.png"
      ],
      moreText: ""
    }
  ];

  const mobileSettings = {
    dots: true,
    infinite: false,
    speed: 400,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  return (
    <div className="flex justify-center py-6">
      {/*Mobile: slider with dots */}
      <div className="w-full block sm:hidden">
        <Slider {...mobileSettings}>
          {cards.map((card) => (
            <div key={card.id}>
              <div className="bg-[#0A2024] rounded-2xl p-4 w-full mx-auto">
                <img
                  src={card.icon}
                  alt={card.title}
                  className="w-[60px] h-[60px] object-contain mb-3"
                />

                <h2 className="text-lg font-bold text-white mb-4">
                  {card.title}
                </h2>

                <p className="text-sm text-white leading-relaxed">
                  {card.description}
                </p>
                <p className="text-sm text-white leading-relaxed">
                  {card.description2}
                </p>
                <div className="flex items-center gap-2 mt-4">
                  {card.logos?.length > 0 && (
                    <div className="flex flex-wrap gap-2">
                      {card.logos.map((logo, index) => (
                        <img
                          key={index}
                          src={logo}
                          alt={`logo-${index}`}
                          className="w-[70px] h-[50px] object-contain"
                        />
                      ))}
                    </div>
                  )}

                  {card.moreText && (
                    <p className="text-xs text-white opacity-80 whitespace-nowrap">
                      {card.moreText}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {/* 🌟 Desktop: normal 3-column grid */}
      <div className="w-full hidden sm:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {cards.map((card) => (
          <div key={card.id} className="bg-[#0A2024] rounded-2xl p-4">
            <img
              src={card.icon}
              alt={card.title}
              className="w-[60px] h-[60px] object-contain mb-3"
            />

            <h2 className="text-lg font-bold text-white mb-4">{card.title}</h2>

            <p className="text-sm text-white leading-relaxed">
              {card.description}
            </p>
            <p className="text-sm text-white leading-relaxed">
              {card.description2}
            </p>

            <div className="flex items-center gap-2 mt-4">
              {card.logos?.length > 0 && (
                <div className="flex flex-wrap gap-2">
                  {card.logos.map((logo, index) => (
                    <img
                      key={index}
                      src={logo}
                      alt={`logo-${index}`}
                      className="w-[70px] h-[50px] object-contain"
                    />
                  ))}
                </div>
              )}

              {card.moreText && (
                <p className="text-xs text-white opacity-80 whitespace-nowrap">
                  {card.moreText}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
